import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'heartcare-web-app-frontend';
  constructor(private router: Router) {}
  ngOnInit() {
    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        let token = localStorage.getItem('jwt_token');
        if (!token) {
          this.router.navigate(['/login']);
        }
      }
    });
  }
}
